<template>
  <v-footer>
    <v-spacer></v-spacer>
    <div class="caption">
      Currículo Web &copy;
      {{ new Date().getFullYear() }} - Versão :
      {{ $store.getters.appVersion }}
    </div>
  </v-footer>
</template>

<script>
export default {
  computed: {
    appVersion() {
      return this.$store.getters.appVersion;
    },
  },
};
</script>
